import classNames from 'classnames';
import { CmsProduct } from '../../types/cmsProduct';
import { ApplyCtaLink } from '../ApplyCta';
import Button from '../Button';
import { MaterialIcon } from '../MaterialIcon';

type CcProductCardActionsProps = {
  product: CmsProduct;
  ctaLinkOverride?: string;
  /** Whether the card has an apply URL at all; without one the primary action is disabled (FR-1.7.4). */
  canApply: boolean;
  /** Opens the product's details in place; without it there is nothing to open and no Details. */
  onDetailsClick?: () => void;
  labels: { details: string; apply: string; notAvailable: string };
  onApplyClick?: () => void;
};

// The small button is 30-36px tall; every action keeps the 44px touch target BRD-01 §4 asks for.
const ACTION_BUTTON = classNames('min-h-11 w-full');

/** Details (secondary, the product's details) and Apply Now (primary, brand orange) (FR-1.7). */
export const CcProductCardActions: React.FC<CcProductCardActionsProps> = ({
  product,
  ctaLinkOverride,
  canApply,
  onDetailsClick,
  labels,
  onApplyClick,
}) => (
  <div
    data-component="cc-product-card-actions"
    className="grid grid-cols-2 gap-spacing/gap/soft-8px"
  >
    {onDetailsClick ? (
      <Button
        onClick={onDetailsClick}
        variant="outline"
        styleType="neutral-light-and-blue"
        size="small"
        className={ACTION_BUTTON}
      >
        {labels.details}
      </Button>
    ) : (
      <div />
    )}
    {canApply ? (
      <ApplyCtaLink
        product={product}
        ctaLinkOverride={ctaLinkOverride}
        target="_blank"
        rel="noreferrer noopener"
        onClick={onApplyClick}
        className="block w-full"
      >
        <Button
          styleType="cta"
          size="small"
          endIcon={<MaterialIcon icon="open_in_new" size={2} />}
          className={ACTION_BUTTON}
        >
          {labels.apply}
        </Button>
      </ApplyCtaLink>
    ) : (
      <Button
        disabled
        size="small"
        className={ACTION_BUTTON}
        data-testid="cc-product-card-apply-unavailable"
      >
        {labels.notAvailable}
      </Button>
    )}
  </div>
);
